var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-block" },
    [_c("vue-mathjax", { attrs: { formula: _vm.body, safe: false } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }